<template>
	<div class="day text-center"
	     :class="{ 'active': active, 'next': next, 'previous': previous }">
		<h4 class="header serif italic">On this day in <strong>{{ year }}</strong></h4>
		<div class="content sans-serif">
			{{{ day.body.value }}}
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	export default {
		props: ['active', 'next', 'previous', 'day'],
		computed: {
			year () {
				return moment(this.day.date).format('YYYY');
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** DayInRacing.vue?3cf31645
 **/